
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import axios from 'axios'
import { Job } from '@/domains/global/models'
import ReturnAlert from '@/domains/jobs/components/Read/ReturnAlert.vue'
import PricingChangesModal from '@/domains/jobs/components/Read/PricingChanges/PricingChangesModal.vue'

@Component({
  components: { PricingChangesModal, ReturnAlert }
})
export default class ReactivateJobSection extends Vue {
  @Prop()
  readonly job!: Job

  get pricingChangesModal() {
    return this.$refs.pricingChangesModal as any
  }

  async reactivateJob() {
    try {
      const response = await axios.get(`/jobs/${this.$route.params.id}/check-pricing`)
      const pricingChanges = response.data as any[]
      if (!pricingChanges.length) {
        await axios.post(`/jobs/${this.$route.params.id}/reactivate`)
        this.$emit('reload')
      } else {
        this.showPricingChanges(pricingChanges)
      }
    } catch (error) {
      this.$store.dispatch('error', 'An error occurred reactivating job')
    }
  }

  async acceptPricingUpdates() {
    try {
      await axios.post(`/jobs/${this.$route.params.id}/reactivate`, { acceptPricingUpdates: true })
      this.$emit('reload')
    } catch (error) {
      await this.$store.dispatch('error', 'An error occurred reactivating job')
    }
  }

  showPricingChanges(pricingChanges: any[]) {
    const modalData = pricingChanges.map((change) => {
      const activity = this.job.activities?.find(activity => change.activityId === activity.id)
      const lineItem = {
        ...change,
        templateTypeName: activity?.templateTypeName,
        isDraft: activity?.isDraft
      }

      return lineItem
    })
    this.pricingChangesModal.open(modalData)
  }
}
